/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CompetitionInputs */

const cs_enum_competition = /** @type {(inputs: Enum_CompetitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konkurence`)
};

const en_enum_competition = /** @type {(inputs: Enum_CompetitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competition`)
};

/**
* | output |
* | --- |
* | "Competition" |
*
* @param {Enum_CompetitionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_competition = /** @type {((inputs?: Enum_CompetitionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CompetitionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_competition(inputs)
	return cs_enum_competition(inputs)
});